var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalMedicalSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.752,
    height: 49.753,
    viewBox: "0 0 47.752 49.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hospital-medical-svgrepo-com",
    transform: "translate(-10.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hospital",
    transform: "translate(10.296 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M84.806,126.116H63.9a5.026,5.026,0,0,1-5.02-5.02V98.254a4.944,4.944,0,0,1,2.273-4.171l12.924-8.338a7.315,7.315,0,0,1,7.917,0l12.924,8.338a4.944,4.944,0,0,1,2.273,4.171v24.915a1.435,1.435,0,0,1-2.871,0V98.254a2.085,2.085,0,0,0-.958-1.759L80.434,88.158a4.439,4.439,0,0,0-4.8,0L62.706,96.5a2.085,2.085,0,0,0-.958,1.759V121.1a2.151,2.151,0,0,0,2.149,2.149H84.806a1.435,1.435,0,1,1,0,2.871Z",
    transform: "translate(-54.156 -76.363)",
    fill: "#2d527c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M56.611,16.81a1.428,1.428,0,0,1-.8-.246L36.65,3.635a4.412,4.412,0,0,0-4.957,0L12.534,16.564a1.435,1.435,0,1,1-1.606-2.38L30.087,1.256a7.271,7.271,0,0,1,8.169,0L57.415,14.184a1.436,1.436,0,0,1-.8,2.626Z",
    transform: "translate(-10.296 0)",
    fill: "#2d527c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M174.447,213.652A2.546,2.546,0,0,0,171.9,216.2v5.115h-8.877V216.2a2.546,2.546,0,0,0-5.091,0v15.32a2.546,2.546,0,0,0,5.091,0V226.4H171.9v5.115a2.546,2.546,0,0,0,5.091,0V216.2A2.546,2.546,0,0,0,174.447,213.652Z",
    transform: "translate(-133.291 -192.891)",
    fill: "#cee8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M161.109,222.162a3.985,3.985,0,0,1-3.981-3.981V214.5h-6.006v3.679a3.981,3.981,0,0,1-7.962,0v-15.32a3.981,3.981,0,1,1,7.962,0v3.679h6.006v-3.679a3.981,3.981,0,1,1,7.962,0v15.32A3.986,3.986,0,0,1,161.109,222.162Zm-11.423-10.531h8.877A1.435,1.435,0,0,1,160,213.067v5.115a1.11,1.11,0,1,0,2.22,0v-15.32a1.11,1.11,0,1,0-2.22,0v5.115a1.435,1.435,0,0,1-1.435,1.435h-8.877a1.435,1.435,0,0,1-1.435-1.435v-5.115a1.11,1.11,0,1,0-2.22,0v15.32a1.11,1.11,0,1,0,2.22,0v-5.115A1.435,1.435,0,0,1,149.687,211.631Z",
    transform: "translate(-119.953 -179.554)",
    fill: "#2d527c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalMedicalSvgrepoCom);
export default __webpack_public_path__ + "static/media/hospital-medical-svgrepo-com.3d4cc7ec80ce81430c1ae0d196fe5e0c.svg";
export { ForwardRef as ReactComponent };